import { type HealthResponse, HealthResponseSchema } from '@vision360/contracts';
import { apiUrl } from './origin';

/**
 * GET /health — unauthenticated, outside /api/v1 (TechSpec §6.1), so it goes
 * through plain fetch rather than the authenticated client.
 */
export async function fetchHealth(doFetch: typeof fetch = fetch): Promise<HealthResponse> {
  const res = await doFetch(apiUrl('/health'), { credentials: 'same-origin' });
  if (!res.ok) throw new Error(`health ${res.status}`);
  return HealthResponseSchema.parse(await res.json());
}
